module.exports = __webpack_public_path__ + "img/ben-career-hero.1717650e.svg";